export enum EventEnum {
  ADD_LOADER_QUEUE_ITEM = 'addLoaderQueueItem',
  REMOVE_LOADER_QUEUE_ITEM = 'removeLoaderQueueItem',
}
